import axios from '../../plugins/axios'

export const listServices = ({ commit }, payload) => {
  const token = JSON.parse(localStorage.getItem('user')).token
  const config = {
    headers: { Authorization: `Bearer ${token}` },
    params: payload ? payload.params : null
  }
  return axios.get('/api/service', config)
    .then((response) => {
      const services = response.data;
      commit('SET_SERVICES', { services })
    },
    (error) => {
      console.log(error);
    })
};

export const editService = ({}, data) => {
  const token = JSON.parse(localStorage.getItem('user')).token
  const config = {
    headers: { Authorization: `Bearer ${token}` }
  }
  return axios.put(`/api/service/${data.id}`, data, config)
    .then((response) => response )
    .catch((error) => error.response );
};

export const deleteService = ({}, id) => {
  const token = JSON.parse(localStorage.getItem('user')).token
  const config = {
    headers: { Authorization: `Bearer ${token}` }
  }
  return axios.delete(`/api/service/${id}`, config)
    .then((response) => response )
    .catch((error) => error.response );
}

export const createService = ({}, data) => {
  const token = JSON.parse(localStorage.getItem('user')).token
  const config = {
    headers: { Authorization: `Bearer ${token}` }
  }
  return axios.post('/api/service', data, config)
    .then((response) => response )
    .catch((error) => error.response );
}

export const getService = ({commit}, id) => {
  const token = JSON.parse(localStorage.getItem('user')).token
  const config = {
    headers: { Authorization: `Bearer ${token}` }
  }
  return axios.get(`/api/service/${id}`, config)
    .then((response) => {
      const service = response.data.service;
      commit('SET_SERVICE', { service });
    })
    .catch((error) => error.response );
}

export const updateServiceMonthsActive = ({}, data) => {
  const token = JSON.parse(localStorage.getItem('user')).token
  const config = {
    headers: { Authorization: `Bearer ${token}` }
  }
  return axios.put(`/api/service/${data.serviceId}/months-active`, data, config)
    .then((response) => response )
    .catch((error) => error.response );
};